import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import * as Rx from 'rxjs';
import { PreloadRouteConfig } from './preload-route.config';
import { PreloadRoute } from './preload-route.service';

@Injectable()
export class OnDemandPreloadingStrategy implements PreloadingStrategy {
  constructor(private preloadRoute: PreloadRoute) {}

  preload(
    route: Route & { data?: PreloadRouteConfig },
    load: Function,
  ): Rx.Observable<any> {
    this.preloadRoute._registerRoute(route, load);
    return Rx.of(null);
  }
}
